import { Component } from 'react';
import {getMainWorkflowStatus} from '../../redux/absences/absencesActions'
import './AbsenceStatusIcon.css'
import AbsenceStatusIcon from './AbsenceStatusIcon.jsx'
import Icon from "@mui/material/Icon/Icon";
import './AbsenceStatusTimeLine.css';

class AbsenceStatusTimeLine extends Component {

    render() {
        let statusIconElements = [];
        let allStatus = getMainWorkflowStatus(this.props.currentStatus);
        for (let i = 0; i < allStatus.length; i++) {
            let status = allStatus[i];

            if(i !== 0 && i !== allStatus.length)
                statusIconElements.push(<Icon key={"arrow-delimitation" + i} className="arrow-delimitation without-side-padding">keyboard_arrow_right</Icon>);

            if(status === this.props.currentStatus){
                statusIconElements.push(<AbsenceStatusIcon className="absence-icon without-side-padding" key={"status-icon" + i} status={status}/>)
                continue;
            }

            statusIconElements.push(<AbsenceStatusIcon  className="absence-icon without-side-padding" key={"status-icon" + i} lowlight status={status}/>)
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="row">
                    {statusIconElements}
                </div>
            </div>
        );
    }
}

export default AbsenceStatusTimeLine;
